import __request__ from "routing/request";
export function resolveEntities(JSONbody, requestOptions) {
  return __request__("POST", "/system/catalog", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function showEntityIndex(requestOptions) {
  return __request__("GET", "/system/catalog", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getTitles(JSONbody, requestOptions) {
  return __request__("POST", "/system/catalog/entities/titles", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
